export default __webpack_public_path__ + "static/media/image-1.92464835.png";